module.exports = __webpack_public_path__ + "img/tcndxq_img3_gray-6.25a9cc38.png";